<template>
  <context-menu>
    <div class="pa-2">
      <e-btn size="M" variant="context" @click="emit('edit')">
        <template #prepend>
          <e-icon name="editPen" />
        </template>
        Редактировать
      </e-btn>
    </div>
  </context-menu>
</template>

<script setup lang="ts">
import ContextMenu from '@/core/components/common/ContextMenu.vue';
import { EBtn, EIcon } from '@/core/components/ui';

const emit = defineEmits<{
  (event: 'edit'): void;
}>();
</script>

<style scoped lang="scss"></style>
